import React, { Component } from 'react';
import { Modal, Grid, Row, Col, Thumbnail, PageHeader } from 'react-bootstrap';
import { invokeApig } from '../libs/awsLib';
import './ViewInventory.css';

const divStyle = {
  backgroundColor: 'rgb(241,241,241)',
};
const circleStyle = {
  borderRadius: '50%',
  width: '50px',
  height: '50px',
  background: '#ccc',
  border: '3px solid #000',
  display: 'table-cell',
  padding: '1em',
  verticalAlign: 'middle',
};

/* TODO: rewrite component without var and prevent next disabled errors */
/* eslint-disable block-scoped-var, vars-on-top, no-var, no-redeclare  */
const dateStringOpts = { year: 'numeric', month: 'short', day: 'numeric' };
function handleExpiration(dateObj, exp) {
  if (Array.isArray(dateObj)) {
    var d = new Date(dateObj[0], dateObj[1] - 1, dateObj[2]);
  } else {
    var d = new Date(dateObj);
  }
  // eslint-disable-next-line no-restricted-globals
  if (!isNaN(parseInt(exp, 10)) && exp > 0) {
    d.setDate(d.getDate() + exp + 1);
    return `${d.toLocaleDateString('en-US', dateStringOpts)} @ 8:00 AM`;
  }
  return 'UNKNOWN';
}

function handleDate(dateObj) {
  if (Array.isArray(dateObj)) {
    const theDate = new Date(dateObj[0], dateObj[1] - 1, dateObj[2]);
    return `${theDate.toLocaleDateString('en-US', dateStringOpts)} @ 8:00 PM`;
  }
  // expecting string to convert from epoch to Date
  const theDate = new Date(dateObj);
  return `${theDate.toLocaleDateString('en-US', dateStringOpts)} @ 8:00 PM`;
}

export default class ViewInventory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      inventory: [],
      timestamp: '',
      modal: {
        show: false,
        item: {
          vendItemName: '',
          items: [],
        },
      },
      kiosk:
        window.location.pathname.split('/')[
          window.location.pathname.split('/').length - 1
        ],
    };
    this.createSingleItem = this.createSingleItem.bind(this);
    this.showModal = this.showModal.bind(this);
    this.transformInventory = this.transformInventory.bind(this);
  }

  async getInventory() {
    try {
      const test = await invokeApig({
        path: `/locations/${this.state.kiosk}/inventory`,
        method: 'GET',
      });

      const parseBody = JSON.parse(test.body);
      let InvPlayloadInfo = parseBody.inventory.payload;
      if (typeof parseBody.inventory.payload === 'string') {
        InvPlayloadInfo = JSON.parse(parseBody.inventory.payload);
      }
      this.setState({
        inventory: this.transformInventory(InvPlayloadInfo),
        timestamp: parseBody.inventory.timestamp,
        kiosk: parseBody.inventory.location,
        images: parseBody.images,
        shelf_life: {},
      });
      if (typeof parseBody.shelf_life !== 'undefined') {
        this.setState({
          shelf_life: parseBody.shelf_life,
        });
      }
    } catch (e) {
      console.error(e);
    }
  }

  async componentDidMount() {
    this.getInventory();
    document.addEventListener(
      'keydown',
      () => {
        const modal = this.state.modal;
        modal.show = false;
        this.setState({ modal });
      },
      false,
    );
  }

  showModal(item) {
    const item_detail = {
      items: JSON.parse(JSON.stringify(item)).restockEvents.reverse(),
      vendItemName: item.vendItemName,
    };
    if (typeof this.state.shelf_life[item.vendItemName] !== 'undefined') {
      item_detail.shelf_life = this.state.shelf_life[item.vendItemName];
    } else {
      item_detail.shelf_life = -1;
    }
    this.setState({
      modal: {
        show: true,
        item: item_detail,
      },
    });
  }

  transformInventory(inventory) {
    const itemKeys = Object.keys(inventory.itemsBySlot).sort();
    let lastX = 0;
    let x;
    let coords;
    const transformedInventory = [[]];
    // eslint-disable-next-line no-restricted-syntax
    for (const key of itemKeys) {
      coords = key.split(',');
      x = parseInt(coords[0].split('(').join(''), 10);
      if (x > lastX) {
        transformedInventory.push([]);
        lastX = x;
      }
      const transformValue = inventory.itemsBySlot[key];
      // flex menu fridges don't receive 'slotItemName'
      if (transformValue.slotItemName) {
        transformValue.vendItemName = transformValue.slotItemName;
      } else if (transformValue.itemsInSlot.length === 0) {
        // we don't get item name from cloud, set string to name
        transformValue.vendItemName = 'EMPTY_SLOT';
      } else {
        // take the first item from the list to get the name
        transformValue.vendItemName =
          transformValue.itemsInSlot[0].vendItemName;
      }
      transformValue.restockEvents = [];
      // eslint-disable-next-line no-restricted-syntax
      for (const item of transformValue.itemsInSlot) {
        transformValue.restockEvents.push(item.productionDate);
      }
      transformedInventory[x].push(transformValue);
    }
    return transformedInventory;
  }

  createSingleItem(item, width) {
    let url = '';
    if (item.vendItemName in this.state.images) {
      url = this.state.images[item.vendItemName];
    } else {
      url = 'https://placehold.it/355x355';
    }
    return (
      <Col key={JSON.stringify(item)} xs={width} className="items">
        <div className="parentThumbnail">
          <Thumbnail
            onClick={() => this.showModal(item)}
            src={url}
            alt="355x355"
            id="productThumbnail"
            style={divStyle}
          >
            <div className="itemName">
              {item.vendItemName.split('_').join(' ')}
            </div>
            <div className="itemName">
              <h3>{item.restockEvents.length}</h3>
            </div>
          </Thumbnail>
        </div>
      </Col>
    );
  }

  createRowVisual(row) {
    let width = 0;
    let spacing = 0;
    switch (row.length) {
      case 6:
        width = 2;
        spacing = 0;
        break;
      case 5:
        width = 2;
        spacing = 1;
        break;
      case 4:
        width = 2;
        spacing = 2;
        break;
      default:
        break;
    }
    return (
      <Row key={JSON.stringify(row)} className="show-grid">
        <Col xs={spacing} />
        {row.map(
          function (item) {
            return this.createSingleItem(item, width);
          }.bind(this),
        )}
        <Col xs={spacing} />
      </Row>
    );
  }

  formatTimestamp(timestamp_string) {
    if (timestamp_string.length < 10) {
      return '';
    }
    return Math.round(
      (new Date().valueOf() -
        new Date(timestamp_string.substring(0, 19)).valueOf()) /
        1000 /
        60,
    );
  }

  createEntireVisual(inventory) {
    const fullPlano = inventory.map(
      function (row) {
        return this.createRowVisual(row);
      }.bind(this),
    );
    return fullPlano;
  }

  render() {
    return (
      <span className="border border-primary">
        <Modal show={this.state.modal.show}>
          <Modal.Header>
            <Modal.Title>
              {this.state.modal.item.vendItemName.split('_').join(' ')}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="updateModalBody">
            <div style={{ verticalAlign: 'middle', display: 'table-cell' }}>
              {this.state.modal.item.items.length === 0 && (
                <div> None in stock </div>
              )}
              {this.state.modal.item.items.length > 0 &&
                this.state.modal.item.items.map((date, index) => (
                  // eslint-disable-next-line react/no-array-index-key
                  <Row key={index}>
                    <Col xs={12}>
                      <div style={circleStyle}>
                        <strong>
                          {this.state.modal.item.items.length - index}
                        </strong>
                      </div>
                      <strong>Produced On: </strong>
                      {handleDate(date)}
                      <br />
                      <strong>Expires On: </strong>
                      {handleExpiration(date, this.state.modal.item.shelf_life)}
                      <hr />
                    </Col>
                  </Row>
                ))}
            </div>
          </Modal.Body>
          <Modal.Footer>
            &nbsp;
            <button
              type="button"
              className="btn modalButtons btn-warning"
              onClick={() => {
                const modal = this.state.modal;
                modal.show = false;
                this.setState({ modal });
              }}
            >
              Close
            </button>
          </Modal.Footer>
        </Modal>
        <Grid>
          <Row className="show-grid">
            <Col xs={12}>
              <PageHeader>
                {this.state.kiosk}{' '}
                <small>
                  {this.formatTimestamp(this.state.timestamp)} minutes ago
                </small>
              </PageHeader>
            </Col>
          </Row>
          {this.createEntireVisual(this.state.inventory)}
        </Grid>
      </span>
    );
  }
}
